import React, { useEffect, useState } from 'react';
import { Box, Form, Input, Button, Alert } from '@intech/web-ui';

import { AuthService, UsuarioService } from "@services";
import { DadosPesquisaEntidade, LoginEntidade, PessoaFisicaEntidade } from "@entidades";

import { Session, } from '@intech/react-service';
import { LoadingComponent, MasterPage } from '@components';

export const ListarParticipantes: React.FC = ({ ...rest }) => {
  const [Cpf, setCpf] = useState("");
  const [Nome, setNome] = useState("");
  const [ResultadoPesquisa, setResultadoPesquisa] = useState<Array<PessoaFisicaEntidade>>(null);

  const [Loading, setLoading] = useState<boolean>(true);
  const [Erro, setErro] = useState<string>("");

  useEffect(() => {
    (async () => {
      setLoading(true);
      try {
        // ...
      } catch (e) {
        const err: any = e;
        setErro(err.response ? err.response.data : err);
      }
      finally {
        setLoading(false);
      }
    })();
  }, []);

  async function pesquisar() {
    try {
      const pesquisa: DadosPesquisaEntidade = {
        Cpf: Cpf,
        Nome: Nome,
        Origem: 1
      }
      const resultadoPesquisa = await UsuarioService.Pesquisar(pesquisa);
      if (resultadoPesquisa) {
        setResultadoPesquisa(resultadoPesquisa);
      }
    }
    catch (e) {
      const err: any = e;
      setErro(err.response ? err.response.data : err);
    }
  }

  async function selecionar(cpf: string) {
    try {
      const pesquisa: LoginEntidade = {
        Cpf: cpf,
        Senha: "",
        SqContratoTrabalho: 0,
        Origem: 1
      }
      var login = await AuthService.Selecionar(pesquisa);

      Session.setToken(login.AccessToken, false);

      document.location.href = '.';
    } catch (e) {
      const err: any = e;
      setErro(err.response ? err.response.data : err);
    }
  }

  return (
    <MasterPage {...rest}>
      {Loading && <LoadingComponent />}

      {!Loading && Erro && <Alert type={"danger"}>{Erro}</Alert>}

      {/* {!Loading && !Erro && ... && <Alert type={"info"}>{"Nenhuma informação disponível no momento."}</Alert>} */}

      {!Loading && !Erro && <>
        <Box title={"Listagem de Participantes"}>
          <Form>
            <Input
              name={"cpf"}
              placeholder={"CPF"}
              value={Cpf}
              onChange={setCpf}
            />

            <Input
              name={"nome"}
              placeholder={"Nome"}
              value={Nome}
              onChange={setNome}
            />

            <Button
              title={"Procurar"}
              type={"primary"}
              onClick={pesquisar}
              loadingText={"Pesquisando..."}
              submit
              usesLoading
            />

          </Form>

          {ResultadoPesquisa !== null && <>
            {ResultadoPesquisa.length === 0 && <Alert className={"mt-2"} type={"danger"}>{"NÂO LOCALIZADO"}</Alert>}

            {ResultadoPesquisa.length > 0 &&
              <div>
                <br />

                <table className={"table"}>
                  <thead>
                    <tr>
                      <th>{"Nome"}</th>
                      <th>{"CPF"}</th>
                      <th></th>
                    </tr>
                  </thead>

                  <tbody>
                    {ResultadoPesquisa.map((pessoa: PessoaFisicaEntidade, index: number) => {
                      return (
                        <tr key={index}>
                          <td>{pessoa.NO_PESSOA}</td>
                          <td>{pessoa.NR_CPF}</td>
                          <td>
                            <Button
                              title={"Selecionar"}
                              type={"primary"}
                              className={"btn-sm"}
                              onClick={async () => selecionar(pessoa.NR_CPF)}
                            />
                          </td>
                        </tr>
                      )
                    })}
                  </tbody>
                </table>
              </div>
            }
          </>}
        </Box>
      </>}
    </MasterPage>
  );
}